import { LabeledValue } from "components/designV2/labeledValue/labeledValue";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { AbsenceType, AGIAbsence } from "model/Salary";
import { formatDuration } from "utils/utils";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { formatIsoDateOnlyInStockholm } from "web-apps/company/utils/timeAndDate";
import { AbsenceRowGrid, SectionContainer } from "./absenceDetailRow.styled";

interface AbsenceDetailRowProps {
  absences: AGIAbsence[];
}

export const AbsenceDetailRow: React.FC<AbsenceDetailRowProps> = (props) => {
  const { t } = useTranslation();

  const formatDate = useCallback((dateString: string): string => {
    return formatIsoDateOnlyInStockholm(dateString);
  }, []);

  const translateAbsenceType = useCallback(
    (type: number): string => {
      switch (type) {
        case AbsenceType.PARENTAL_LEAVE:
          return t("Salary.parentalLeave");
        case AbsenceType.VAB:
          return t("Salary.VAB");
        default:
          return "-";
      }
    },
    [t],
  );

  const renderAbsenceRow = useCallback(
    (absence: AGIAbsence, index: number, totalLength: number) => {
      const isLastRow = index === totalLength - 1;
      return (
        <AbsenceRowGrid
          $isLastRow={isLastRow}
          key={`absence-${absence.date}-${index}`}
        >
          <LabeledValue
            value={formatDate(absence.date)}
            label={t("Salary.Date")}
            variant="small"
          />
          <LabeledValue
            value={translateAbsenceType(absence.type)}
            label={t("Salary.Type")}
            variant="small"
          />
          <LabeledValue
            value={formatDuration(absence.hours.toString())}
            label={t("Salary.Hours")}
            variant="small"
          />
        </AbsenceRowGrid>
      );
    },
    [t, formatDate, translateAbsenceType],
  );

  if (props.absences.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      <Text typography="h5" color={ColorV2.Blue1}>
        {t("Salary.Absence")}
      </Text>
      {props.absences.map((absence, index) =>
        renderAbsenceRow(absence, index, props.absences.length),
      )}
    </SectionContainer>
  );
};
